(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/models/draw.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/models/draw.js');


'use strict';

const _svs$utils$format = svs.utils.format,
  Currency = _svs$utils$format.Currency,
  CurrencyFromJupiterString = _svs$utils$format.CurrencyFromJupiterString,
  CurrencyInMillions = _svs$utils$format.CurrencyInMillions;
const ShortDateAndTime = svs.utils.date.ShortDateAndTime;
const Draw = Backbone.Model.extend({
  initialize() {},
  setData(draw, currentDrawNumber) {
    let extraText = '';
    let extraMoneyTitle = 'Extrapengar: ';
    if (svs.core.detect.formfactor.mobile()) {
      extraMoneyTitle = 'Extra: ';
    }
    if (draw.attributes.currentJackpot) {
      extraText = "Jackpot: ca ".concat(this.formatCurrencyMilj(draw.attributes.currentJackpot), " kr");
    } else if (draw.attributes.fund !== null) {
      if (draw.attributes.fund.extraMoney !== '0,00') {
        extraText = "".concat(extraMoneyTitle + Currency(draw.attributes.fund.extraMoney), " kr");
      } else if (draw.attributes.fund.rolloverIn !== '0,00') {
        extraText = "Rullpott: ".concat(Currency(draw.attributes.fund.rolloverIn), " kr");
      }
    }
    const modelData = {
      regCloseTime: dateFns.format(new Date(draw.attributes.regCloseTime), "d MMMM', kl.' HH:mm", {
        locale: dateFns.locales.sv
      }),
      description: draw.attributes.description || "Vecka ".concat(draw.attributes.week),
      drawsstate: draw.attributes.drawState,
      jackpot: draw.attributes.currentJackpot,
      currentNetSale: draw.attributes.currentNetSale || draw.attributes.currentNetSales,
      drawNumber: draw.attributes.drawNumber,
      isCurrentDraw: currentDrawNumber === draw.attributes.drawNumber,
      extraText
    };
    this.set(modelData);
  },
  formatCurrencyMilj(number) {
    if (typeof number === 'string') {
      number = CurrencyFromJupiterString(number);
    }
    return number > 999999 ? "".concat(CurrencyInMillions(number), " milj.") : Currency(number, false);
  }
});
setGlobal('svs.sport.drawselector.models.Draw', Draw);

 })(window);